import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './PractitionersDetails.css';
import FormatUrl from '../../utils/UrlFormatter';
import { getClinicId } from '../../utils/config';

const PractitionersDetails = ({ logged_in, user }) => {
  // const location = useLocation();
  const { id } = useParams(); // Get practitioner ID from URL
  const [clinicId, setClinicId] = useState( getClinicId(user) || user?.clinic_id || null);
  const [practitioner, setPractitioner] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPractitioners = async () => {
      if (!clinicId) {
        setError('Clinic ID is missing.');
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const resolveClinicId = clinicId ?? getClinicId(user) ?? user?.clinic_id;
        const apiUrl = FormatUrl(`/get-doctors/?clinic_id=${resolveClinicId}`);

        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Failed to fetch practitioners. Status: ${response.status}, Message: ${errorText}`);
        }

        const data = await response.json();

        const selectedPractitioner = data.practitioners.find(
          (practitioner) => practitioner.id.toString() === id
        );

        if (selectedPractitioner) {
          setPractitioner(selectedPractitioner);
          setError(null);
        } else {
          setError('Practitioner not found.');
        }
      } catch (error) {
        console.error('Error fetching practitioner details:', error);
        setError('Failed to load practitioner details.');
      } finally {
        setIsLoading(false);
      }
    };

    // Handle missing `clinicId` on refresh or navigation
    const finalClinicId = getClinicId(user) ?? user?.clinic_id;

    if (!clinicId && finalClinicId) {
      setClinicId(finalClinicId);
    } else if (clinicId) {
      fetchPractitioners();
    } else {
      setIsLoading(false);
    }
  }, [id, clinicId, user]);

  // Show loading spinner
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // Show error message
  if (error) {
    return <div className="error-message">{error}</div>;
  }

  // Display practitioner details
  if (!practitioner) {
    return <div>Loading practitioner details...</div>;
  }

  return (
    <div className="practitioner-details-container">
      <div className="practitioner-header">
        {/* Image Section */}
        <div className="practitioner-image-container">
          <img
            src={`https://via.placeholder.com/300x300?text=${practitioner.firstName}+${practitioner.lastName}`}
            alt={`${practitioner.firstName} ${practitioner.lastName}`}
            className="practitioner-image"
          />
        </div>

        {/* Practitioner Details Section */}
        <div className="practitioner-details">
          <h1 className="practitioner-name">
            Dr. {practitioner.firstName} {practitioner.lastName}
          </h1>
          <h2 className="practitioner-title">{practitioner.discipline || 'Specialist'}</h2>
          <p className="practitioner-license">
            <strong>License Number:</strong> {practitioner.licenseNumber || 'N/A'}
          </p>
          <p className="practitioner-intro">
            Providing the highest quality care for all patients with a dedication to their well-being and recovery.
          </p>
        </div>
      </div>

      {/* About Me Section */}
      <div className="about-me-section">
        <h2>About Me</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin vitae nisl at orci luctus bibendum a
          et felis. Suspendisse potenti. Aenean auctor neque ac justo suscipit, ut vehicula turpis accumsan.
        </p>
        <p>
          Praesent sit amet augue id sapien placerat luctus. Vestibulum euismod sapien nec dolor scelerisque, at
          ultrices mi vehicula. Integer id eros ut ipsum gravida sollicitudin.
        </p>
        <p>
          When not practicing, you might find Dr. {practitioner.lastName} hiking, enjoying live music, or spending quality time with family and friends.
        </p>
      </div>
    </div>
  );
};

export default PractitionersDetails;
